import { IconDeviceDesktop, IconUserCircle } from '@tabler/icons-react';
import { Button, Card, Grid, Group, Modal, Stack, Text, Title } from '@mantine/core';

const TestMethodSelectionModal = ({ show, close, onSelectBrowserPreview, onSelectRealUser }) => {
  return (
    <Modal size="lg" opened={show} onClose={close} title="Choose Test Method" centered>
      <Grid gap="md">
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Card
            padding="lg"
            radius="md"
            withBorder
            style={{ cursor: 'pointer', height: '100%' }}
            onClick={() => {
              onSelectBrowserPreview();
              close();
            }}
          >
            <Stack align="center" justify="center" gap="md">
              <IconDeviceDesktop size={48} color="var(--mantine-color-primary-6)" />
              <Title order={5}>Preview in This Browser</Title>
              <Text c="dimmed" ta="center" size="sm">
                Test how the notification looks in your current browser. Quick preview - no user data needed.
              </Text>
            </Stack>
          </Card>
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6 }}>
          <Card
            padding="lg"
            radius="md"
            withBorder
            style={{ cursor: 'pointer', height: '100%' }}
            onClick={() => {
              onSelectRealUser();
              close();
            }}
          >
            <Stack align="center" justify="center" gap="md">
              <IconUserCircle size={48} color="var(--mantine-color-green-6)" />
              <Title order={5}>Send to a Real User</Title>
              <Text c="dimmed" ta="center" size="sm">
                Send to an actual user's device to test with real profile data and personalization.
              </Text>
            </Stack>
          </Card>
        </Grid.Col>
      </Grid>
      <Group justify="flex-end" mt="md">
        <Button variant="default" onClick={close}>
          Cancel
        </Button>
      </Group>
    </Modal>
  );
};

export default TestMethodSelectionModal;
